/**
 * Common chart configuration and color schemes
 */

// Main color palette for all charts
export const CHART_COLORS = [
  '#321fdb', // Primary blue
  '#2eb85c', // Success green
  '#f9b115', // Warning yellow
  '#e55353', // Danger red
  '#768192', // Secondary gray
  '#3399ff', // Light blue
  '#20c997', // Teal
  '#fd7e14', // Orange
  '#6f42c1', // Purple
  '#20c997', // Mint
];

// Common chart options that can be extended
export const getDefaultChartOptions = (colors = CHART_COLORS) => ({
  backgroundColor: 'transparent',
  chartArea: {
    top: "5%",
    width: '85%',
    height: '70%'
  },
  fontSize: 12,
  fontName: 'system-ui',
  colors: colors,
  legend: {
    position: "bottom",
    alignment: "center",
    textStyle: { fontSize: 14 },
  },
});

// Specific area type configurations
export const getAreaChartOptions = (colors = CHART_COLORS.slice(0, 3)) => ({
  ...getDefaultChartOptions(colors),
  pointSize: 1,
  hAxis: { 
    title: "UTC+0",
    showTextEvery: 2  // Show every second label
  },
});

// Specific chart type configurations
export const getLineChartOptions = (colors = CHART_COLORS.slice(0, 3)) => ({
  ...getDefaultChartOptions(colors),
  pointSize: 2,
});

export const getPieChartOptions = (colors = CHART_COLORS) => ({
  ...getDefaultChartOptions(colors),
  chartArea: {
    top: "5%",
    width: '95%',
    height: '75%'
  },
  tooltip: { 
    text: 'both',
    showColorCode: true
  }
});

export const getBarChartOptions = (colors = CHART_COLORS.slice(0, 3)) => ({
  ...getDefaultChartOptions(colors),
  isStacked: true,
  chartArea: {
    top: "5%",
    width: '70%',
    height: '75%'
  },
});